// THEME PROVIDER

import ThemeProvider from "@/theme/theme-provider";
// PRODUCT CART PROVIDER

import CartProvider from "@/contexts/CartContext";
// SITE SETTINGS PROVIDER

import SettingsProvider from "@/contexts/SettingContext";
// GLOBAL CUSTOM COMPONENTS

import ProgressBar from "@/components/progress";
import Header from "@/components/header/index.js";
import {SearchInputWithCategory} from "@/components/search-box/index.js";
import {useCallback, useEffect, useRef, useState} from "react";
import Sticky from "@/components/sticky/index.js";
import Topbar from "@/components/topbar/index.js";
import {Navbar} from "@/components/navbar/index.js";
import {Footer1} from "@/components/footer";
import {usePage} from "@inertiajs/react";
import {Alert, Snackbar} from "@mui/material";
import useCart from "@/hooks/useCart.js";
import EmailVerificationBanner from "@/components/EmailVerificationBanner";

export default ({children, categories, query, category, auth, canResetPassword}) => {
    const {state: cart} = useCart();
    const [isFixed, setIsFixed] = useState(false);
    const toggleIsFixed = useCallback(fixed => setIsFixed(fixed), []);
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [alert, setAlert] = useState({
        type: '',
        text: '',
    });
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackBarOpen(false);
    };
    const firstUpdate = useRef(true);
    useEffect(() => {
        console.log(cart)
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        setAlert({
            type: 'success',
            text: 'Cart has been updated successfully.',
        })
        setSnackBarOpen(true);
    }, [cart]);
    return (
        <div style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
            <ThemeProvider>
                <EmailVerificationBanner />
                <Topbar/>
                <Sticky fixedOn={0} onSticky={toggleIsFixed} scrollDistance={300}>
                    <Header categories={categories} isFixed={isFixed} auth={auth} canResetPassword={canResetPassword}
                            midSlot={<SearchInputWithCategory categories={categories} category={category}
                                                              query={query?.q}/>}/>
                </Sticky>
                <Navbar categories={categories} elevation={0} border={1} user={auth.user}/>
                <div style={{flex: 1}}>
                    {children}
                    <Snackbar
                        sx={{zIndex: 10000}}
                        autoHideDuration={500}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                        open={snackBarOpen}
                        onClose={handleClose}
                    >
                        <Alert
                            onClose={handleClose}
                            severity={alert.type}
                            // sx={{ width: '100%' }}
                        >
                            {alert.text}
                        </Alert>
                    </Snackbar>
                </div>
                <Footer1/>
            </ThemeProvider>
        </div>
    )

}


